/**
 * Created by Christof Sander on 21.12.2016.
 */

module.exports = {
	config: {
		addNewElementsAllowed: true,
		focusAble: true,
		scrollOffsetStart: 44
	},

	model: {
		open: false,
		dataJSON: []
		// values: {},
		// newValues: []
	},

	events: {
		change: function (event) {
			// prevent default change
			event.preventDefault();
			event.stopImmediatePropagation();
		},
		click: function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			var self = event.data.component;
			var $target, $realTarget;

			// open
			if(($target = $(event.target)).length > 0 && ($realTarget = $target.closest('button.open')).length > 0){
				self.open();
			}
			// remove
			else if(($realTarget = $target.closest('button.delete')).length > 0 && ($realTarget = $realTarget.closest('li')).length > 0){
				self.unChoose($realTarget);
			}
			// add
			else if(($realTarget = $target.closest('li')).length > 0 && $realTarget.closest('.optionList').length > 0){
				self.choose($realTarget);
			}
		},
		close: {
			type: 'focusout',
			action: function (event) {
				var $focusTarget, $closestComponent;
				if(
					event.data.component.model.open &&
					($focusTarget = $(event.relatedTarget)).length > 0 &&
					($closestComponent = $focusTarget.closest('[data-component-index]')).length > 0 &&
					!$closestComponent.is(event.data.component.$)
				){
					event.data.component.close();
				}
			}
		},
		open: {
			type: 'focusin',
			action: function (event) {
				if(!event.data.component.model.open){
					event.data.component.open();
				}
			}
		},
		select: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;

				// close
				if(event.key === 'Escape'){
					event.preventDefault();
					event.stopImmediatePropagation();

					self.close();
				}
				else {
					var validKeyFound = true;

					// arrow down
					var $activeElement;
					if(event.key === 'ArrowDown'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						else {
							do { $activeElement = $activeElement.next(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						$activeElement.addClass('selected');


						var offsetStart = self.model.$optionList.find('> li').first().position().top;
						var offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart;
						if(offset > 0){
							self.model.$optionList.scrollTop(offset);
						}
						else {
							self.model.$optionList.scrollTop(0);
						}
					}
					else if(event.key === 'ArrowUp'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last();
						}
						else {
							do { $activeElement = $activeElement.prev(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last();
						}
						$activeElement.addClass('selected');

						var offsetStart = self.model.$optionList.find('> li').first().position().top;
						var offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart;
						if(offset > 0){
							self.model.$optionList.scrollTop(offset);
						}
						else {
							self.model.$optionList.scrollTop(0);
						}
					}
					else if(event.key === 'Enter'){
						var $target;
						if(($activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)')).length > 0){
							self.choose($activeElement);
						}
						else if(($target = $(event.target).closest('input')).length > 0){
							var $existingElement = false;
							var filterValue = $target.val();
							self.model.$optionList.find('> li').each(function(index){
								if($(this).text() == filterValue){
									$existingElement = $(this);
									return false;
								}
							});

							// existing element
							if($existingElement){
								self.choose($existingElement);
							}
							// new element
							else if(filterValue) {
								self.addNewElement(filterValue);
							}
						}
					}
					else {
						validKeyFound = false;
					}

					if(validKeyFound){
						event.preventDefault();
						event.stopImmediatePropagation();
					}
				}
			}
		},
		filter: {
			type: 'keyup',
			selector: 'input',
			action: function(event){
				switch(event.key){
					case 'ArrowUp':
					case 'ArrowDown':
					case 'Escape':
					case 'Tab':
					case 'Enter':
						break;

					default:
						var target = event.originalEvent ? event.originalEvent.target : event.target;
						event.data.component.filter(target.value);
						break;
				}
			}
		}
	},

	methods: {
		// dataDealer: function(){
		// 	var self = this;
		// 	this.parent(function(relationComponent){
		// 		if(relationComponent.hasClass('base_form_fields_relation')){
		// 			self.model.values = relationComponent.model.values;
		// 		}
		// 	});
		// },
		//
		// sanitizeResources: function(){
		// 	console.log('SANI');
		// },

		open: function(){
			if(this.model.nrOfActiveElements > 0 || this.config.addNewElementsAllowed){
				this.$.addClass('active');
				this.model.open = true;
				this.model.$filterField.focus();
			}
		},
		close: function(){
			this.$.removeClass('active');
			this.model.open = false;
		},
		choose: function($option){
			$option.addClass('disabled').removeClass('selected');


			var value = {};
			var target = value;
			if(this.model.config.relationConfig){
				value.attributes = {};
				target = value.attributes;
			}
			var relationDataIndex = $option.data('index');
			var type = 'create';
			if(relationDataIndex === '' || relationDataIndex === undefined) {
				relationDataIndex = this.model.dataJSON.length;
			}
			else {
				type = 'keep';
			}

			if(this.model.config.relationConfig) {
				target[this.model.config.relationConfig.assignedPrimaryKey] = $option.data('value');
				value.type = type;
				this.model.dataJSON[relationDataIndex] = value;
			}
			this.model.parentComponent.trigger('onChildChanged', {
				isRelation: 			!!this.model.config.relationConfig,
				relationConfig: 		this.model.config.relationConfig,
				relationDataIndex:  	relationDataIndex,
				fieldCode:  			this.model.fieldCode,
				value: 					value,
				type: 					type
			});

			this.model.$valueList.append(
				this.include('./autoCompleteBubbleOption', { model: { value: $option.data('value'), name: $option.text(), relationDataIndex: relationDataIndex, valueItem: true }})
			);

			if(this.model.nrOfActiveElements == 0 && !this.config.addNewElementsAllowed){
				this.close();
			}
		},
		unChoose: function($option){
			var value = {};
			var target = value;
			if(this.model.config.relationConfig){
				value.attributes = {};
				target = value.attributes;
			}
			var relationDataIndex = $option.data('index');
			var type = 'delete';
			if(relationDataIndex === '' || relationDataIndex === undefined) {
				console.error('unable to remove element whithout dataIndex')
				return;
			}
			else if(this.model.dataJSON[relationDataIndex]){
				value = this.model.dataJSON[relationDataIndex];
				if(this.model.config.relationConfig){
					target = value.attributes;
				}
			}
			if(this.model.config.relationConfig) {
				target[this.model.config.relationConfig.assignedPrimaryKey] = $option.data('value');
				if(value.type === 'create'){
					this.model.dataJSON = this.model.dataJSON.splice(relationDataIndex, 1);
					type = 'ignore';
				}
			}
			this.model.parentComponent.trigger('onChildChanged', {
				isRelation: 			!!this.model.config.relationConfig,
				relationConfig: 		this.model.config.relationConfig,
				relationDataIndex:  	relationDataIndex,
				fieldCode:  			this.model.fieldCode,
				value: 					value,
				type: 					type
			});

			$option.remove();
		},
		filter: function(filterValue){
			var regExp = new RegExp(filterValue, 'i');
			var $element, value;
			var self = this;
			self.model.nrOfActiveElements = 0;
			self.model.$optionList.find('> li').each(function(index){
				$element    = $(this);
				value       = $element.text();

				if(value == '' || value.match(regExp)){
					$element.addClass('active').removeClass('selected');
					self.model.nrOfActiveElements++;
				}
				else {
					$element.removeClass('active selected');
				}
			});

			if(self.model.nrOfActiveElements == 0 && !self.config.addNewElementsAllowed){
				this.close();
			}
			else if(!this.model.open){
				this.open();
			}
		},
		addNewElement: function(value){
			// check if element has been added previously
			var newValueIndex;
			for(newValueIndex in this.model.newValues){
				if(this.model.newValues[newValueIndex].value == value){
					return;
				}
			}

			// add new value if necessary
			this.model.newValues.push({
				value: value,
				name: ''
			});
			var $newElement;
			this.model.$optionList.append(($newElement = $(this.include('./autoCompleteBubbleOption', { model: { value: '', name: value }}))));
			this.model.$valueList.append($newElement);
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			if(!this.model.parentComponent){
				this.parent(function(parentComponent){
					self.model.parentComponent = parentComponent;
				});
			}
			if(!this.model.$filterField || this.model.$filterField.length <= 0){
				this.model.$filterField = $element.find('input');
			}
			if(!this.model.$optionListContainer || this.model.$optionListContainer.length <= 0){
				this.model.$optionListContainer = $element.find('.optionList');
			}
			if(!this.model.$optionList || this.model.$optionList.length <= 0){
				this.model.$optionList = this.model.$optionListContainer.find('> ul');
			}
			if(!this.model.$valueListContainer || this.model.$valueListContainer.length <= 0){
				this.model.$valueListContainer = $element.find('.valueList');
			}
			if(!this.model.$valueList || this.model.$valueList.length <= 0){
				this.model.$valueList = this.model.$valueListContainer.find('> ul');
			}

			// init filter
			var value = this.model.$filterField.val();
			this.filter(value);
			if(!options.refresh) this.close();
		}
	}
};
